<template>
  <div id="facecare-terms-of-use-view">
    <header class="term-header">
      <div class="term-title-container">
        <div class="term-title">{{ $t("termsOfUse.title") }}</div>
      </div>
    </header>

    <component :is="FacecareTermsOfUse" id="license-article" />
  </div>
</template>

<script>
import { defineAsyncComponent } from "vue";
import store from "@/utils/store";

export default {
  components: {},
  data() {},
  computed: {
    FacecareTermsOfUse() {
      return defineAsyncComponent(() =>
        import(
          `../../components/terms-of-use/FacecareTermsOfUseText_${store.currentLocale.value}.vue`
        )
      );
    },
  },
  mounted() {},
  created() {
    /*
    ローカルテスト用URL
    http://localhost:8080/#/withpb-terms-of-use
    */
  },
  methods: {},
};
</script>

<style scoped>
:root {
  --header-title-height: 42px;
}

.term-header {
  box-sizing: border-box;
  padding: 0;
  padding: 16px;
  height: var(--header-title-height);
  width: 100%;
}

.term-title-container {
  height: var(--header-title-height);
  width: 100%;
}

.term-title {
  height: 100%;
  text-align: center;
  font: normal normal normal 18px/26px Noto Sans JP;
  letter-spacing: 0px;
  color: #000000e6;
  opacity: 1;
}

#license-article {
  box-sizing: border-box;
  padding-left: 16px;
  padding-right: 16px;
  /* 半角英数字を折り返す */
  word-wrap: break-word;
  overflow-wrap: break-word;
  background-color: #ffffff;
}
</style>
